// src/components/aiWaitCopy.js
//
// Pure copy + threshold for the "AI is working" wait affordance. The AI calls are
// non-streamed and take ~20s, so the wait needs to read as intentional, not broken:
// a calm expectation-setting line while working, and -- after a short continuous
// wait -- a reassurance that a good answer just takes a moment. No seconds are ever
// shown to the user; the escalation is purely a "still working" reassurance.
//
// JSX-free so it unit-tests under `node --test`.

// How long a single continuous wait runs before we escalate the copy. Deliberately
// not surfaced in the UI as a number -- it only decides which line shows.
export const AI_WAIT_ESCALATE_MS = 9000;

const WAIT_COPY = {
    chat: {
        initial: 'Thinking through your pack material...',
        escalated: 'Still working -- a good answer takes a moment.',
    },
    grading: {
        initial: 'Marking your essay against the mark scheme...',
        escalated: 'Still marking -- a careful read takes a moment.',
    },
};

// The line to show for a surface ('chat' | 'grading') given whether the wait has
// crossed the escalation threshold. Unknown surfaces fall back to the chat copy so
// a caller typo degrades to a sensible line rather than undefined.
export function aiWaitCopy(surface, escalated) {
    const copy = WAIT_COPY[surface] || WAIT_COPY.chat;
    return escalated ? copy.escalated : copy.initial;
}
